import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaRelatorioResponse } from '../../responses/relatorio-interno/lista-relatorio.response';
import { RelatorioResponse } from '../../responses/relatorio-interno/relatorio.response';

@Injectable({
  providedIn: 'root',
})
export class MeusRelatoriosService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }
  public get(titulo: string, perfilAcesso: string, paginaAtual: number): Observable<ListaRelatorioResponse> {
    const uri: string = `MeusRelatorios?titulo=${titulo}&perfilAcesso=${perfilAcesso}&paginaAtual=${paginaAtual}`;

    return this.httpClient
      .get<ListaRelatorioResponse>(environment.urlApiRelatorioInterno + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public ObterPorId(idRelatorio: number): Observable<RelatorioResponse> {
    return this.httpClient
      .get<RelatorioResponse>(
        environment.urlApiRelatorioInterno + `MeusRelatorios/idRelatorio/${idRelatorio}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
